import { useEffect, useRef, useState } from 'react';

// Mounts heavy children only when scrolled near the viewport (keeps prerendered HTML small)
export const LazyMount = ({ children, fallback = null, minHeight = 300 }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || !('IntersectionObserver' in window)) { setShow(true); return; }
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setShow(true); io.disconnect(); } }, { rootMargin: '300px' });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return <div ref={ref} style={{ minHeight: show ? undefined : minHeight }} data-testid="lazy-mount">{show ? children : fallback}</div>;
};
